/**
 * Vanilla Next (vn) API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const RecipeType = {
    INPUT_PRODUCT: 'INPUT_PRODUCT',
    OUTPUT_PRODUCT: 'OUTPUT_PRODUCT'
} as const;
export type RecipeType = typeof RecipeType[keyof typeof RecipeType];

